import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { write, utils } from 'xlsx'
import Loader from '../../common/Loader.js'
import MUIDataTable from 'mui-datatables'
import Constant, { getCountryTimeZone } from '../../Constant'
import Moment from 'react-moment'
import axios from 'axios'
import Swal from 'sweetalert2'
moment.tz = require('moment-timezone')

const WalletReport = () => {
  const [pageData, setPageData] = useState({
    currency: 'KWD',
    walletAmount: 0,
    wallet_data: {
      expired_wallet_total: 0,
      expirable_wallet_total: 0,
      wallet_total: 0,
      used_reworded_wallet_total: 0,
    },

    filtered_wallet_data: {
      normal_balance: 0,
      expirable_balance: 0,
      wallet_total: 0,
      expired_balance: 0,
      used_balance: 0,
    },
  })

  const [filter, setFilters] = useState({
    pageNumber: 0,
    country: localStorage.getItem('countryShortName') || 'KWT',

    type: '',
    user_keyword: '',

    start_date: '',
    end_date: '',

    status: '',
  })
  const [countries, setCountries] = useState([])
  const [list, setList] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    loadCountries()
    return () => {}
  }, [])

  useEffect(() => {
    let tempPageData = { ...pageData }

    tempPageData.filtered_wallet_data.expired_balance = list.reduce((accumulator, transaction) => {
      if (moment(transaction.expired_at).isBefore(moment.utc())) {
        return accumulator + transaction.amount
      } else {
        return accumulator
      }
    }, 0)

    tempPageData.filtered_wallet_data.expirable_balance = list.reduce((accumulator, transaction) => {
      if (moment(transaction.expired_at).isAfter(moment.utc())) {
        return accumulator + transaction.amount
      } else {
        return accumulator
      }
    }, 0)

    tempPageData.filtered_wallet_data.used_balance = list.reduce((accumulator, transaction) => {
      if (transaction.type == 'RWD' && transaction.is_redeemed) {
        return accumulator + transaction.amount
      } else {
        return accumulator
      }
    }, 0)

    setPageData({
      ...tempPageData,
    })
    // eslint-disable-next-line
  }, [list])

  const loadWallethistory = async () => {
    setIsLoading(true)

    await axios
      .get(Constant.getAPI() + '/user/wallet-history/', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
        params: {
          country: filter.country,
          type: filter.type,
          user_id: filter.user_keyword,
          start_date: filter.start_date,
          end_date: filter.end_date,
          status: filter.status,
        },
      })
      .then((res) => {
        if (res.data.success) {
          setList(res?.data?.data?.history || [])
          setPageData({
            ...pageData,
            currency: res?.data?.data?.currency || 'KWD',
            walletAmount: res?.data?.data?.walletAmount || 0,
            wallet_data: res?.data?.data?.wallet_data || {
              expirable_wallet_total: 0,
              expired_wallet_total: 0,
              wallet_total: 0,
            },
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  const loadCountries = async () => {
    await axios
      .get(Constant.getAPI() + '/multi-country/list-countries?show_all_countries=true', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name:
            localStorage.getItem('loged_In_role') === 'super-admin'
              ? ''
              : `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res?.data?.success) {
          setCountries(res?.data?.data || [])
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  const showDetails = (id) => {
    const bookingData = list?.find((ele) => ele.id === id)

    if (bookingData?.details?.walletPayment?.length > 0) {
      const content = `
    <div>
      <table style="width:100%">
        <tbody>
          <tr>
            <th></th>
            ${bookingData?.details?.walletPayment.map((item, index) => `<th style="text-align: left">Payment ${index + 1}</th>`)}
          </tr>
          <tr>
            <th>Payment ID</th>
            ${bookingData?.details?.walletPayment.map((item) => `<td style="text-align: left">${item.payment_id || '--'}</td>`)}
          </tr>
          <tr>
            <th>Payment Status</th>
            ${bookingData?.details?.walletPayment.map((item) => '<td style="text-align: left">' + (item.payment_status || '--') + '</td>')}
          </tr>
          <tr>
            <th>Payment Method</th>
            ${bookingData?.details?.walletPayment.map((item) => '<td style="text-align: left">' + (item?.payment_method?.PaymentMethod_en || '--') + '</td>')}
          </tr>
          <tr>
            <th>Payment Amount</th>
            ${bookingData?.details?.walletPayment.map((item) => '<td style="text-align: left">' + (item.payment_currency || this.state.currency) + ' ' + item.payment_amount + '</td>')}
          </tr>
          <tr>
            <th>Transaction ID</th>
            ${bookingData?.details?.walletPayment.map((item) => '<td style="text-align: left">' + (item.txn_id || '--') + '</td>')}
          </tr>
          <tr>
            <th>Invoice Reference ID</th>
            ${bookingData?.details?.walletPayment.map((item) => '<td style="text-align: left">' + (item.payment_info.InvoiceReference || '--') + '</td>')}
          </tr>
        </tbody>
      </table>
    </div>
`
      Swal.fire({
        width: '1000px',
        title: '<strong>Payment Details</strong>',
        html: content,
      })
    } else {
      Swal.fire({
        title: '<strong>Payment Details Not Found</strong>',
        icon: 'error',
        type: 'error',
      })
    }
  }

  const handleFilterChange = (event) => {
    let tempFilters = filter

    tempFilters[event?.target?.name] = event?.target?.value

    if (event?.target?.name == 'type') {
      tempFilters.status = ''
    }

    setFilters({ ...tempFilters })
  }

  const clearSearch = () => {
    setFilters({
      pageNumber: 0,
      country: localStorage.getItem('countryShortName') || 'KWT',

      type: '',
      user_keyword: '',

      start_date: '',
      end_date: '',
    })

    setList([])
  }

  const columns = [
    {
      name: 'id',
      label: 'id',
      options: {
        display: false,
      },
    },
    {
      name: 'img',
      label: 'Type',
      options: {
        customBodyRender: (value) => {
          return (
            <>
              <img
                src={Constant.getImage() + value}
                className="img-fluid img-50"
                alt="img"
                onError={(event) => {
                  event.currentTarget.src = './assets/images/no_image.png'
                }}
                style={{ borderRadius: 25 }}
              />
            </>
          )
        },
      },
    },
    {
      name: 'type',
      label: 'Action Type',
      options: {
        customBodyRender: (data) => {
          return (
            <div style={{ textWrap: 'nowrap' }}>
              {data == 'ADD' && 'Wallet Recharge'}
              {data == 'REF' && 'Refund'}
              {data == 'SUB' && 'Spent on Booking'}
              {data == 'REDV' && 'Redeem Voucher'}
              {data == 'RWD' && 'Reword'}
            </div>
          )
        },
      },
    },
    {
      name: 'transaction_type',
      label: 'Transaction Type',
      options: {
        customBodyRender: (data) => {
          return (
            <div style={{ textWrap: 'nowrap' }}>
              {data == 'C' && 'Cruise Booking'}
              {data == 'E' && 'Event Booking'}
              {data == 'S' && 'Store Booking'}
              {data == 'CH' && 'Chalet Booking'}
              {data == 'V' && 'Recharge'}
              {data == 'PAY' && 'Recharge'}
              {!data && '--'}
            </div>
          )
        },
      },
    },
    {
      name: 'details',
      label: 'Details',
      options: {
        customBodyRender: (data, tableMeta) => {
          return (
            <div style={{ textWrap: 'nowrap' }}>
              {tableMeta.rowData[3] == 'C' && (
                <span>
                  Booking ID -{' '}
                  <Link
                    to={'/booking-ordering/' + data.id}
                    className="m-r-15 text-primary"
                  >
                    {data.order_number}
                  </Link>
                </span>
              )}
              {tableMeta.rowData[3] == 'E' && (
                <span>
                  Booking ID -{' '}
                  <Link
                    to={'/new-evt/' + data.id}
                    className="m-r-15 text-primary"
                  >
                    {data.order_number}
                  </Link>
                </span>
              )}
              {tableMeta.rowData[3] == 'S' && (
                <span>
                  Booking ID -{' '}
                  <Link
                    to={'/store-bookings-details/' + data.id}
                    className="m-r-15 text-primary"
                  >
                    {data.order_number}
                  </Link>
                </span>
              )}
              {tableMeta.rowData[3] == 'CH' && (
                <span>
                  Booking ID -{' '}
                  <Link
                    to={'/chalet-booking-details/' + data?.id}
                    className="m-r-15 text-primary"
                  >
                    {data?.order_number}
                  </Link>
                </span>
              )}
              {tableMeta.rowData[3] == 'PAY' && '--'}
              {tableMeta.rowData[3] == 'V' && <span>{`Voucher Code - ${data?.code}`}</span>}
            </div>
          )
        },
      },
    },
    {
      name: 'amount',
      label: 'Amount',
      options: {
        customBodyRender: (data) => {
          return (
            <>
              {data > 0 ? (
                <span className="text-success font-weight-bold">{data}</span>
              ) : (
                <span className="text-danger font-weight-bold">{data}</span>
              )}
            </>
          )
        },
      },
    },
    {
      name: 'comment_en',
      label: 'Comment En',
      options: {
        customBodyRender: (data) => {
          return <div style={{ textWrap: 'nowrap' }}>{data || '--'}</div>
        },
      },
    },
    {
      name: 'comment_ar',
      label: 'Comment Ar',
      options: {
        customBodyRender: (data) => {
          return <div style={{ textWrap: 'nowrap' }}>{data || '--'}</div>
        },
      },
    },
    {
      name: 'dbo_user',
      label: 'User ID',
      options: {
        customBodyRender: (data) => {
          return (
            <div style={{ textWrap: 'nowrap' }}>
              <span>{data.id || '--'}</span>
            </div>
          )
        },
      },
    },
    {
      name: 'dbo_user',
      label: 'User Email',
      options: {
        customBodyRender: (data) => {
          return (
            <div style={{ textWrap: 'nowrap' }}>
              <span>{data.email || '--'}</span>
            </div>
          )
        },
      },
    },
    {
      name: 'dbo_user',
      label: 'User Phone',
      options: {
        customBodyRender: (data) => {
          return (
            <div style={{ textWrap: 'nowrap' }}>
              <span>
                {data.country_code} {data.phone}
              </span>
            </div>
          )
        },
      },
    },
    {
      name: 'expired_at',
      label: 'Status',
      options: {
        customBodyRender: (data, tableMeta) => {
          return tableMeta.rowData[2] == 'RWD' ? (
            <>
              {moment.utc(data).isAfter(moment.utc()) && (
                <span className="badge badge-pill badge-warning">Pending</span>
              )}
              {moment.utc(data).isBefore(moment.utc()) && (
                <span className="badge badge-pill badge-secondary">Exrired</span>
              )}
              {!data && <span className="badge badge-pill badge-success">Used</span>}
            </>
          ) : (
            '--'
          )
          // <span className="badge badge-pill badge-warning">In Progress</span>
        },
      },
    },
    {
      name: 'created_at',
      label: 'Transaction Date',
      options: {
        customBodyRender: (data) => {
          return (
            <div style={{ textWrap: 'nowrap' }}>
              <Moment format="YYYY-MM-DD hh:mm:ss A">{data}</Moment>
            </div>
          )
        },
      },
    },
    {
      name: 'expired_at',
      label: 'Expiry Date',
      options: {
        customBodyRender: (data) => {
          return data ? (
            <div style={{ textWrap: 'nowrap' }}>
              <Moment format="YYYY-MM-DD hh:mm:ss A">{data}</Moment>
            </div>
          ) : (
            '--'
          )
        },
      },
    },
    {
      name: 'payment',
      label: 'Payment Details',
      options: {
        customBodyRender: (data, tableMeta) => {
          const bookingData = list?.find((ele) => ele.id === tableMeta.rowData[0])

          return bookingData?.details?.walletPayment?.length > 0 ? (
            <img
              className="img-fluid m-l-5"
              src="./assets/images/info.png"
              alt="ico"
              style={{ width: 13 }}
              onClick={() => showDetails(tableMeta.rowData[0])}
            />
          ) : (
            '--'
          )
        },
      },
    },
  ]

  const typeMapping = {
    ADD: 'Wallet Recharge',
    REF: 'Refund',
    SUB: 'Spent on Booking',
    REDV: 'Redeem Voucher',
    RWD: 'Reword',
  }

  const transactionTypeMapping = {
    C: 'Cruise Booking',
    E: 'Event Booking',
    S: 'Store Booking',
    CH: 'Chalet Booking',
    V: 'Recharge',
    PAY: 'Recharge',
  }

  const options = {
    filter: false,
    filterType: 'dropdown',
    viewColumns: false,
    print: false,
    download: true,
    downloadOptions: {
      filename: 'WalletReport',
    },
    onDownload: (buildHead, buildBody, columns, values) => {
      const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
      const fileExtension = '.xlsx'
      const fileName = `WalletReport`

      const json = values.reduce((result, val) => {
        const temp = {}

        val.data.forEach((v, idx) => {
          if (columns[idx].name == 'img' || columns[idx].name == 'id') {
            //
          } else if (columns[idx].name == 'payment') {
            const bookingData = list?.find((ele) => ele.id === val.data[0])
            if (bookingData?.details?.walletPayment?.length > 0) {
              let payment = bookingData?.details?.walletPayment.find((ele) => ele.payment_status == 'PAID')

              if (payment) {
                temp['Payment ID'] = payment.payment_id || ''
                temp['Payment Amount'] = payment.payment_amount || ''
                temp['Payment Currency'] = payment.payment_currency || ''
                temp['Payment Status'] = payment.payment_status || ''
                temp['Transaction ID'] = payment.txn_id || ''
                temp['Payment Method'] = payment?.payment_method?.PaymentMethod_en || ''
                temp['Invoice Reference ID'] = payment?.payment_info?.InvoiceReference || ''
              }
            }
          } else if (columns[idx].name == 'type') {
            temp[columns[idx].label] = typeMapping[v] || ''
          } else if (columns[idx].name == 'transaction_type') {
            temp[columns[idx].label] = transactionTypeMapping[v] || ''
          } else if (columns[idx].name == 'details') {
            temp[columns[idx].label] =
              val.data[idx - 1] == 'C' ||
              val.data[idx - 1] == 'E' ||
              val.data[idx - 1] == 'S' ||
              val.data[idx - 1] == 'CH'
                ? 'Booking ID:- ' + v?.order_number
                : val.data[idx - 1] == 'PAY'
                  ? ''
                  : val.data[idx - 1] == 'V'
                    ? 'Voucher Code:- ' + v?.code
                    : ''
          } else if (columns[idx].name == 'dbo_user') {
            temp['User Email'] = v?.email
            temp['User Phone'] = v?.country_code + ' ' + v?.phone
          } else if (columns[idx].name == 'created_at') {
            temp['Transaction Date'] = moment(v)
              .tz(getCountryTimeZone(localStorage.getItem('countryShortName')))
              .format('YYYY-MM-DD hh:mm:ss A')
          } else if (columns[idx].name == 'expired_at') {
            temp['Expired Date'] = v
              ? moment(v)
                  .tz(getCountryTimeZone(localStorage.getItem('countryShortName')))
                  .format('YYYY-MM-DD hh:mm:ss A')
              : ''

            if (!v) {
              temp['Status'] = 'Used'
            } else if (moment.utc(v).isAfter(moment.utc())) {
              temp['Status'] = 'Pending'
            } else if (moment.utc(v).isBefore(moment.utc())) {
              temp['Status'] = 'Exrired'
            }
          } else {
            temp[columns[idx].label] = v
          }
        })

        result.push(temp)
        return result
      }, [])

      const ws = utils.json_to_sheet(json)
      const wb = { Sheets: { data: ws }, SheetNames: ['data'] }
      const excelBuffer = write(wb, { bookType: 'xlsx', type: 'array' })
      const blob = new Blob([excelBuffer], { type: fileType })
      const file = new File([blob], fileName + fileExtension, { type: fileType })

      const downloadLink = document.createElement('a')
      downloadLink.href = URL.createObjectURL(file)
      downloadLink.download = file.name

      downloadLink.click()

      // cancel default  CSV download from table
      return false
    },
    selectableRows: 'none',
    textLabels: {
      body: {
        noMatch: isLoading ? <Loader open={isLoading} /> : 'Sorry, No data Found',
        toolTip: 'Sort',
        columnHeaderTooltip: (column) => `Sort for ${column.label}`,
      },
    },
  }

  return (
    <>
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-end">
                <div className="col-lg-8">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>Wallet Report</h4>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="page-header-breadcrumb">
                    <ul className="breadcrumb-title">
                      <li className="breadcrumb-item">
                        <Link to="/">
                          <i className="feather icon-home"></i>{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">Wallet Report</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="page-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card card-border-default">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Action type</label>
                            <div className="col-sm-9">
                              <select
                                name="type"
                                className="form-control"
                                value={filter.type}
                                onChange={handleFilterChange}
                              >
                                <option value={''}>All</option>
                                <option value={'ADD'}>Wallet Recharge</option>
                                <option value={'REF'}>Refund</option>
                                <option value={'SUB'}>Spent on Booking</option>
                                <option value={'REDV'}>Redeem Voucher</option>
                                <option value={'RWD'}>Reword</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Country</label>
                            <div className="col-sm-9">
                              <select
                                name="country"
                                className="form-control"
                                value={filter.country}
                                onChange={handleFilterChange}
                              >
                                {countries.map((country) => (
                                  <option
                                    value={country.country_short_name}
                                    key={country.country_short_name}
                                  >
                                    {country.country_name_en + '/' + country.country_name_ar}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">User Search</label>
                            <div className="col-sm-9">
                              <input
                                type="text"
                                name="user_keyword"
                                className="form-control"
                                onChange={handleFilterChange}
                                value={filter.user_keyword}
                                placeholder="Search - User Id | Email | Phone"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Trans Start Date</label>
                            <div className="col-sm-9">
                              <input
                                type="date"
                                name="start_date"
                                className="form-control"
                                onChange={handleFilterChange}
                                value={filter.start_date}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Trans End Date</label>
                            <div className="col-sm-9">
                              <input
                                type="date"
                                max={moment().format('YYYY-MM-DD')}
                                name="end_date"
                                className="form-control"
                                onChange={handleFilterChange}
                                value={filter.end_date}
                              />
                            </div>
                          </div>
                        </div>
                        {filter.type == 'RWD' && (
                          <div className="col-md-4">
                            <div className="form-group row">
                              <label className="col-sm-3 col-form-label">Status</label>
                              <div className="col-sm-9">
                                <select
                                  name="status"
                                  className="form-control"
                                  value={filter.status}
                                  onChange={handleFilterChange}
                                >
                                  <option value={''}>All</option>
                                  <option value={'pending'}>Pending</option>
                                  <option value={'expired'}>Expired</option>
                                  <option value={'used'}>Used</option>
                                </select>
                              </div>
                            </div>
                          </div>
                        )}
                        <div className="col-md-12">
                          <div className="row">
                            <div
                              className="col-6"
                              style={{ color: 'red' }}
                            >
                              {/* You can get maximum 6 months rocords at a time */}
                            </div>
                            <div className="text-right col-6">
                              {isLoading ? (
                                <button
                                  className="btn btn-grd-disabled"
                                  disabled
                                  style={{ width: 150 }}
                                >
                                  Searching...!
                                </button>
                              ) : (
                                <>
                                  <button
                                    style={{ width: 150 }}
                                    className="btn btn-inverse waves-effect m-r-10"
                                    onClick={clearSearch}
                                  >
                                    Clear
                                  </button>
                                  <button
                                    style={{ width: 150 }}
                                    onClick={loadWallethistory}
                                    className="btn btn-inverse waves-effect"
                                  >
                                    Search
                                  </button>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card card-border-default">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-1"></div>
                        <div className="col-md-4">
                          <div
                            className="row"
                            style={{ fontSize: 18 }}
                          >
                            <div className="col-12 text-center font-weight-bold">Full Record</div>

                            <div className="col-7">Normal Balance: </div>
                            <div className="col-5 text-right">
                              {pageData?.wallet_data?.wallet_total + ' ' + pageData.currency}
                            </div>
                            <div className="col-7">Expirable Balance: </div>
                            <div className="col-5 text-right">
                              {pageData?.wallet_data?.expirable_wallet_total + ' ' + pageData.currency}
                            </div>
                            <div
                              className="col-12"
                              style={{ borderTop: '2px solid #000' }}
                            ></div>
                            <div className="col-7">Total Balance in wallets: </div>
                            <div className="col-5 text-right">{pageData.walletAmount + ' ' + pageData.currency}</div>
                            <div
                              className="col-12"
                              style={{ borderTop: '2px solid #000' }}
                            ></div>
                            <div className="col-7 text-danger">Expired Balance: </div>
                            <div className="col-5 text-right text-danger">
                              {pageData?.wallet_data?.expired_wallet_total + ' ' + pageData.currency}
                            </div>
                            <div className="col-7">Used Reworded Balance: </div>
                            <div className="col-5 text-right">
                              {pageData?.wallet_data?.used_reworded_wallet_total + ' ' + pageData.currency}
                            </div>
                          </div>
                        </div>
                        <div className="col-md-2"></div>
                        <div className="col-md-4">
                          <div
                            className="row"
                            style={{ fontSize: 18 }}
                          >
                            <div className="col-12 text-center font-weight-bold">Filtered Records</div>

                            <div className="col-7">Used Reworded Balance: </div>
                            <div className="col-5 text-right">
                              {pageData?.filtered_wallet_data?.used_balance + ' ' + pageData.currency}
                            </div>
                            <div className="col-7">Expirable Reworded Balance: </div>
                            <div className="col-5 text-right">
                              {pageData?.filtered_wallet_data?.expirable_balance + ' ' + pageData.currency}
                            </div>
                            <div className="col-7 text-danger">Expired Reworded Balance: </div>
                            <div className="col-5 text-right text-danger">
                              {pageData?.filtered_wallet_data?.expired_balance + ' ' + pageData.currency}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card card-border-default">
                    <div className="dt-responsive table-responsive">
                      <MUIDataTable
                        title={'Report'}
                        className="table-responsive"
                        data={list}
                        columns={columns}
                        options={options}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default WalletReport
